import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/logo_wwt.png'
import _imports_1 from './assets/logo_nf.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }),
  /*#__PURE__*/_createElementVNode("p", null, "Loading …")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { id: "overlays" }
const _hoisted_6 = { id: "controls" }
const _hoisted_7 = { class: "tooltip-content tool-menu" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { id: "tools" }
const _hoisted_12 = { class: "tool-container" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Foreground opacity:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Background imagery:", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 2,
  class: "playback-controls"
}
const _hoisted_17 = { id: "credits" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<p> Powered by <a href=\"https://worldwidetelescope.org/home/\" target=\"_blank\">WorldWide Telescope</a><a href=\"https://worldwidetelescope.org/home/\" target=\"_blank\"><img alt=\"WWT Logo\" src=\"" + _imports_0 + "\"></a><a href=\"https://numfocus.org/\" target=\"_blank\"><img alt=\"NumFOCUS Logo\" src=\"" + _imports_1 + "\"></a></p>", 1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_vue_slider = _resolveComponent("vue-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WorldWideTelescope, {
      "wwt-namespace": "wwt-embed",
      style: _normalizeStyle({
        height: _ctx.wwtComponentLayout.height,
        top: _ctx.wwtComponentLayout.top,
      })
    }, null, 8, ["style"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
          [_vShow, _ctx.isLoadingState]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "modal",
          id: "modal-readytostart",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startInteractive()))
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_font_awesome_icon, {
              class: "icon",
              icon: "play"
            })
          ])
        ], 512), [
          [_vShow, _ctx.isReadyToStartState]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("p", null, _toDisplayString(_ctx.coordText), 513), [
            [_vShow, _ctx.embedSettings.showCoordinateReadout]
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_6, [
      _withDirectives(_createElementVNode("li", null, [
        _createVNode(_component_Popper, {
          placement: "left",
          arrow: true,
          interactive: true
        }, {
          content: _withCtx((props) => [
            _createElementVNode("ul", _hoisted_7, [
              _withDirectives(_createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: ($event: any) => {
                    _ctx.selectTool('crossfade');
                    props.close()
                  }
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "adjust" }),
                  _createTextVNode(" Crossfade")
                ], 8, _hoisted_8)
              ], 512), [
                [_vShow, _ctx.showCrossfader]
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: ($event: any) => {
                    _ctx.selectTool('choose-background');
                    props.close()
                  }
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "mountain" }),
                  _createTextVNode(" Choose background")
                ], 8, _hoisted_9)
              ], 512), [
                [_vShow, _ctx.showBackgroundChooser]
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: ($event: any) => {_ctx.selectTool('playback-controls');
                    props.close()
                  }
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "redo" }),
                  _createTextVNode(" Tour player controls")
                ], 8, _hoisted_10)
              ], 512), [
                [_vShow, _ctx.showPlaybackControls]
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              class: "tooltip-target",
              icon: "sliders-h",
              size: "lg"
            })
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.showToolMenu]
      ]),
      _withDirectives(_createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, {
          icon: "search-plus",
          size: "lg",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doZoom(true)))
        })
      ], 512), [
        [_vShow, !_ctx.wwtIsTourPlaying]
      ]),
      _withDirectives(_createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, {
          icon: "search-minus",
          size: "lg",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doZoom(false)))
        })
      ], 512), [
        [_vShow, !_ctx.wwtIsTourPlaying]
      ]),
      _withDirectives(_createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, {
          icon: _ctx.fullscreenModeActive ? 'compress' : 'expand',
          size: "lg",
          class: "nudgeright1",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleFullscreen()))
        }, null, 8, ["icon"])
      ], 512), [
        [_vShow, _ctx.fullscreenAvailable]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.currentTool == 'crossfade')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                class: "opacity-range",
                type: "range",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.foregroundOpacity) = $event))
              }, null, 512), [
                [_vModelText, _ctx.foregroundOpacity]
              ])
            ], 64))
          : (_ctx.currentTool == 'choose-background')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.curBackgroundImagesetName) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundImagesets, (bg) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: bg.imagesetName,
                      key: bg.imagesetName
                    }, _toDisplayString(bg.displayName), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.curBackgroundImagesetName]
                ])
              ], 64))
            : (_ctx.currentTool == 'playback-controls')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.tourPlaybackIcon,
                    size: "lg",
                    class: "clickable",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tourPlaybackButtonClicked()))
                  }, null, 8, ["icon"]),
                  _createVNode(_component_vue_slider, {
                    class: "scrubber",
                    modelValue: _ctx.twoWayTourTimecode,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.twoWayTourTimecode) = $event)),
                    max: _ctx.wwtTourRunTime,
                    marks: _ctx.wwtTourStopStartTimes,
                    "tooltip-formatter": _ctx.formatTimecode,
                    adsorb: true,
                    duration: 0,
                    interval: 0.001,
                    contained: true,
                    "hide-label": true,
                    "use-keyboard": false
                  }, null, 8, ["modelValue", "max", "marks", "tooltip-formatter"])
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_19, 512), [
      [_vShow, _ctx.embedSettings.creditMode == _ctx.CreditMode.Default]
    ])
  ]))
}